import React from 'react';
import { Server } from '../../server/server';
import { BsFillXCircleFill } from 'react-icons/bs';
import AlertModal from './AlertModal';
import './Modal.css'
import './LoginModal.css'

interface ChangeEmailModalProps {
  open: boolean;
  onClose: Function;
}

interface ChangeEmailModalState {
  email: string;
  code: string;
  message: string;
  alert: string;
  mode: string;
  processing: boolean;
}

class ChangeEmailModal extends React.Component<ChangeEmailModalProps, ChangeEmailModalState> {
  constructor(props:ChangeEmailModalProps) {
    super(props);

    this.state = {
      email: '',
      code: '',
      message: '',
      alert: '',
      mode: 'change',
      processing: false,
    }

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onCodeChange = this.onCodeChange.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onConfirmEmail = this.onConfirmEmail.bind(this);
    this.onClose = this.onClose.bind(this);
  }
  
  onEmailChange(e: React.FormEvent<HTMLInputElement>): void {
    this.setState({email: e.currentTarget.value, message: ''});
  };

  onCodeChange(e: React.FormEvent<HTMLInputElement>): void {
    this.setState({code: e.currentTarget.value, message: ''});
  };

  onKeyDown(e:any): void {
    if (e.key === 'Enter') {
      switch(this.state.mode) {
        case 'change': 
          this.onChangeEmail();
          break;
        case 'confirm': 
          this.onConfirmEmail();
          break;
      }
    }
  };

  onClose() {
    if(!this.state.processing)
      this.close();
  }

  close() {
    this.setState({mode: 'change', alert: '', message: '', processing: false})
    this.props.onClose();
  }

  setMode(mode:string) {
    this.setState({mode: mode, message: ''});
  }

  setMessage(s:string) {
    this.setState({message: s});
  }

  setAlert(s:string) {
    this.setState({alert: s});
  }

  clearAlert() {
    this.setState({alert: ''});
  }

  startProcessing() {
    this.setState({processing: true});
  }

  stopProcessing() {
    this.setState({processing: false});
  }

  async onChangeEmail() {
    if(this.state.email.length == 0 || this.state.email.indexOf('.') == -1 || this.state.email.indexOf('@') == -1) {
      this.setMessage('Email address is not valid.');
      return;
    }

    this.startProcessing();

    let response = await Server.account.changeEmail(this.state.email);

    this.stopProcessing();

    if(response.success) 
      this.setMode('confirm');
    else 
      this.setMessage(response.message);
  }

  async onConfirmEmail() {
    if(this.state.code.length == 0) {
      this.setMessage('Code cannot be blank.');
      return;
    }

    this.startProcessing();

    let response = await Server.account.verifyEmail(this.state.code);

    this.stopProcessing();

    if(response.success) 
      this.setAlert('Email address changed.');
    else 
      this.setMessage(response.message);
  }

  renderProcessingButton(text:string, callback:Function) {
    if(this.state.processing)
      return (<button disabled={true}><i className="fa fa-circle-o-notch fa-spin"></i>&nbsp;&nbsp;{text}</button>)
    else
      return (<button onClick={()=>callback()}>{text}</button>)
  }

  renderMessage() {
    if(this.state.message == '')
      return null;
    return (<div className="login-modal-error">{this.state.message}</div>);
  }

  renderChangeEmail() {
    return (
      <div>
        <div style={{textAlign: 'center'}}>Enter your new email address.</div>
        <div>
          Email:<br />
          <input type="email" value={this.state.email} onChange={this.onEmailChange} onKeyDown={this.onKeyDown}></input>
        </div>
        {this.renderMessage()}
        <div>
          {this.renderProcessingButton('Change', this.onChangeEmail)}
        </div>
      </div>
    )
  }

  renderConfirmEmail() {
    return (
      <div>
        <div style={{textAlign: 'center'}}>Enter the confirmation code sent to your email address.</div>
        <div>
        Code:<br />
          <input value={this.state.code} onChange={this.onCodeChange} onKeyDown={this.onKeyDown}></input>
        </div>
        {this.renderMessage()}
        <div>
          {this.renderProcessingButton('Confirm', this.onConfirmEmail)}
        </div>
      </div>
    )
  }

  render() {
    if(!this.props.open)
      return (<div></div>);

    if(this.state.alert != '')
      return (<AlertModal message={this.state.alert} button="OK" onClose={this.onClose}/>)

    let content = null;
    switch(this.state.mode) {
      case 'change':
        content = this.renderChangeEmail();
        break;
      case 'confirm':
        content = this.renderConfirmEmail();
        break;
    }

    if(!content)
      return (<div></div>);

    return (
      <div className="modal open">
        <div className="login-modal-content">
          {content}
        </div>
      </div>
    )
  }
}

export default ChangeEmailModal;